import { render, staticRenderFns } from "./NotificationTable.vue?vue&type=template&id=2944d9b4"
import script from "./NotificationTable.vue?vue&type=script&lang=js"
export * from "./NotificationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports